module.exports = __webpack_public_path__ + "img/instruction2.2178088a.jpg";